<template>
  <div class="intellectual-property">
    <div class="intellectual-property-chart">
      <div class="intellectual-property-table">
        <div class="intellectual-property-table-item">
          <div class="intellectual-property-table-item-title">专利总量</div>
          <div class="intellectual-property-table-item-value">
            {{ totalNumberOfPatents }}
          </div>
        </div>
        <div class="intellectual-property-table-item">
          <div class="intellectual-property-table-item-title">申请人主体</div>
          <div class="intellectual-property-table-item-value">
            {{ applicantSubject }}
          </div>
        </div>
        <div class="intellectual-property-table-item">
          <div class="intellectual-property-table-item-title">专利许可</div>
          <div class="intellectual-property-table-item-value">
            {{ patentLicense }}
          </div>
        </div>
        <div class="intellectual-property-table-item">
          <div class="intellectual-property-table-item-title">专利转让</div>
          <div class="intellectual-property-table-item-value">
            {{ patentTransfer }}
          </div>
        </div>
      </div>
      <div
        class="intellectual-property-pic"
        id="intellectualPropertyChart"
      ></div>
    </div>
    <div class="intellectual-property-base-info">
      <div class="base-info-title">发明专利授权总量占比</div>
      <div class="base-info-content">
        <div class="base-info-left"></div>
        <div class="base-info-right">
          <div class="account-for">
            <div class="account-for-number" :style="{ width: `${proportion}%` }">
              {{ proportion }}%
            </div>
          </div>
          <div class="text-info">
            <div class="text-info-item">
              <div class="text-info-item-icon"></div>
              <div class="text-info-item-text">
                发明专利授权总量:{{ authorizedInventionPatentsNumber }}
              </div>
            </div>
            <div class="text-info-item">
              <div class="text-info-item-icon"></div>
              <div class="text-info-item-text">
                授权专利总量:{{ authorizedPatentsNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { ajax } from "@/config/ppm-request.js";
export default {
  name: "intellectual-property",
  data() {
    return {
      intellectualPropertyChart: null,
      totalNumberOfPatents: "", // 专利总量
      applicantSubject: "", // 申请人主体
      patentLicense: "", // 专利许可
      patentTransfer: "", // 专利转让
      // domesticPatents: '', // 国内专利总量
      // foreignPatents: '', // 国外专利总量
      // domesticAuthorization: '', // 国内授权量
      // foreignAuthorization: '', // 国外授权量
      authorizedInventionPatentsNumber: "", // 发明专利授权总量
      authorizedPatentsNumber: "", // 授权专利总量
      proportion: "", // 占比
    };
  },
  beforeDestroy() {
    // 清理图表实例
    if (this.intellectualPropertyChart) {
      this.intellectualPropertyChart.dispose();
    }
  },
  mounted() {
    ajax.get("/zsck/bi/intelligenceProperty").then((res) => {
      this.totalNumberOfPatents = res.patentQtt;
      this.applicantSubject = res.digitalPatent;
      this.patentLicense = res.patentPermission;
      this.patentTransfer = res.transferQtt;
      this.authorizedInventionPatentsNumber =
        res.inventAuthQtt;
      this.authorizedPatentsNumber = res.authorityPatent;
      this.proportion = res.proportion;
      this.intellectualPropertyChart = echarts.init(
        document.getElementById("intellectualPropertyChart")
      );
      
      // 确保图表能够响应窗口大小变化
      window.addEventListener('resize', () => {
        if (this.intellectualPropertyChart) {
          this.intellectualPropertyChart.resize();
        }
      });

      this.intellectualPropertyChart.setOption({
        xAxis: {
          type: "category",
          data: ["专利总量", "授权量"],
          axisLabel: {
            color: "#ffffff", // 设置字体颜色为白色，提高对比度
            fontSize: "0.8rem", // 增大字体大小
            interval: 0, // 强制显示所有标签
          },
          axisLine: {
            lineStyle: {
              color: "#293b52", // X轴线的颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: "#293b52", // 设置分割线颜色
            },
          },
          axisTick: {
            show: false, // 显示刻度线
            alignWithLabel: true, // 刻度线与标签对齐
            lineStyle: {
              color: "#293b52", // X轴刻度线的颜色
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#ccc",
          },
          min: 0,
          splitNumber: 4,
          splitLine: {
            lineStyle: {
              color: "#293b52", // 设置分割线颜色
            },
          },
          // interval: 200,
        },
        grid: {
          left: 5,
          right: "0%",
          bottom: "3%",
          top: "26%",
          containLabel: true,
        },
        color: ["#10589e", "#1e7d9d"],
        legend: {
          textStyle: {
            color: "#ccc", // 设置图例文字颜色
            fontSize: "0.8rem",
          },
          itemHeight: 10,
          itemWidth: 10,
          icon: "circle",
          data: ["国内", "国外"],
        },
        series: [
          {
            name: "国内",
            data: [res.domesticPatent, res.domesticAuthorityPatent],
            type: "bar",
            label: {
              show: true, // 显示标签
              position: "top", // 标签的位置，这里是顶部
              textStyle: {
                color: "#ccc",
                fontSize: "1rem",
              },
            },
          },
          {
            name: "国外",
            data: [res.overseaPatent, res.overseaAuthorityPatent],
            type: "bar",
            label: {
              show: true, // 显示标签
              position: "top", // 标签的位置，这里是顶部
              textStyle: {
                color: "#ccc",
                fontSize: "1rem",
              },
            },
          },
        ],
      });
    });
  },
};
</script>

<style lang="less" scoped>
.intellectual-property {
  width: 100%;
  height: 100%;
  .intellectual-property-chart {
    height: 60%;
    display: flex;
    overflow: hidden;
    padding: 0 6%;
    .intellectual-property-table {
      width: 49%;
      height: 100%;
      padding: 8% 4% 4% 0;
      box-sizing: border-box;
      .intellectual-property-table-item {
        height: 23%;
        margin-bottom: 2%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background: url(/src/assets/imgs/intellectualPropertyBack.png) center
          center / contain no-repeat;
        .intellectual-property-table-item-title {
          flex: 1;
          color: #a7aaad;
          font-size: 0.8rem;
          padding-left: 10%;
        }
        .intellectual-property-table-item-value {
          font-size: 1.2rem;
          color: #18a9e7;
        }
      }
    }
    .intellectual-property-pic {
      margin-left: 2%;
      width: 49%;
      height: 100%;
      padding: 4% 0 4% 0;
      box-sizing: border-box;
    }
  }
  .intellectual-property-base-info {
    height: 40%;
    margin: 0 4%;
    border-top: 1px solid #435068;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .base-info-title {
      font-size: 0.8rem;
      color: #b3b3b3;
      opacity: 0.7;
      margin: 3% 0;
      padding-left: 4%;
    }
    .base-info-content {
      flex: 1;
      display: flex;
      padding-bottom: 6%;
      .base-info-left {
        width: 25%;
        background: url(/src/assets/imgs/intellectualPropertyAccountBack.png)
          center center / contain no-repeat;
      }
      .base-info-right {
        padding: 0 2% 0 0;
        width: 73%;
        .account-for {
          height: 36%;
          border-radius: 12px;
          background: #1e3b5e;
          .account-for-number {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            color: #c8ced5;
            border-radius: 12px;
            font-size: 0.6rem;
            background: linear-gradient(to right, #275097, #6895b7);
          }
        }
        .text-info {
          height: 60%;
          margin-top: 4%;
          box-sizing: border-box;
          border-radius: 10px;
          border: 1px solid #3d4b63;
          .text-info-item {
            height: 50%;
            display: flex;
            align-items: center;
            padding-left: 16%;
            .text-info-item-icon {
              height: 0.8rem;
              width: 0.8rem;
              border-radius: 50%;
              background: linear-gradient(to right, #275097, #6895b7);
            }
            .text-info-item-text {
              padding-left: 6px;
              font-size: 0.6rem;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>>